import React from "react";
import { Typography } from "@material-ui/core";
import type { FC } from "react";
import { useStyles } from "./styles";

export const RecentlyCardsTitle: FC = ({ children }) => {
  const classes = useStyles();
  const adapter: any = {
    subtitle1: classes.title,
  };
  return (
    <Typography component="span" variant="subtitle1" classes={adapter}>
      {children}
    </Typography>
  );
};
